// TODO: call this array blocked routes and remove 'blocked.*' state
export const blockedStateRoutes = ['get-first-new-number', 'login', 'welcome', 'plans', 'first-steps'];

export function isCurrentRouteBlocked(currentRoute: string = window.location.href): boolean {
  return blockedStateRoutes.some(url => currentRoute.includes(url));
}
